<div class="container">
  <form [formGroup]="form">
    <div *ngFor="let question of questions" class="form-group">
      <label [for]="question.questionId">{{ question.questionText }}
        <span *ngIf="question.mandatory" class="required">*</span>
      </label>

      <!-- Input Types -->
      <input *ngIf="['input', 'url', 'email', 'phone', 'currency'].includes(question.controlType)"
        [type]="question.controlType === 'currency' ? 'number' : question.controlType" [id]="question.questionId"
        [formControlName]="question.questionId.toString()" class="form-control" [placeholder]="question.questionText"
        [min]="question.validation?.min" [max]="question.validation?.max" [minlength]="question.validation?.minLength"
        [maxlength]="question.validation?.maxLength" [step]="question.controlType === 'currency' ? '0.01' : null" />

      <!-- Range Slider -->
      <div *ngIf="question.controlType === 'range'" class="range-slider">
        <!-- <label [for]="question.questionId">{{ question.questionText }}</label> -->
        <input type="range"
               [id]="question.questionId"
               [formControlName]="question.questionId.toString()"
               class="form-control"
               [min]="question.validation?.min"
               [max]="question.validation?.max" />

        <!-- Display the current selected value -->
        <span class="range-value">
          {{ form.get(question.questionId.toString())?.value || question.validation?.min }}
        </span>
      </div>


      <!-- Radio Buttons -->
      <div *ngIf="question.controlType === 'radio'">
        <div *ngFor="let option of question.options" class="form-check">
          <input type="radio" [id]="option.id" [value]="option.text" [formControlName]="question.questionId.toString()"
            class="form-check-input" />
          <label [for]="option.id" class="form-check-label">{{ option.text }}</label>
        </div>
      </div>

      <!-- Select Dropdown -->
      <select *ngIf="question.controlType === 'select'" [id]="question.questionId"
        [formControlName]="question.questionId.toString()" class="form-select">
        <option *ngFor="let option of question.options" [value]="option.text">
          {{ option.text }}
        </option>
      </select>

      <!-- Error Message -->
      <div *ngIf="form.get(question.questionId.toString())?.invalid && isSubmit" class="text-danger">
        {{ getErrorMessage(question.questionId.toString()) }}
      </div>
    </div>
  </form>
</div>
